// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-content {
  width: 90% !important;
  overflow-x: hidden;
}
.media-content .field {
  width: 90% !important;
}
.media-content .edit-text-box .text-input {
  width: 100% !important;
}

::ng-deep .empty-head-icon {
  padding-top: 5px !important;
  background-image: linear-gradient(to top, #accbee 0%, #e7f0fd 100%) !important;
}

input[type=search]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
  padding-bottom: 3px;
  margin: 4px 0px 0px 0px;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/app/components/notification/notification-details/sub-post/sub-post.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,kBAAA;AACJ;AAAI;EACI,qBAAA;AAER;AAAI;EACI,sBAAA;AAER;;AACA;EACI,2BAAA;EACA,8EAAA;AAEJ;;AAEA;EACI,6CAAA;EAEA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAAJ","sourcesContent":[".media-content{\n    width:90% !important;\n    overflow-x: hidden;\n    .field{\n        width:90% !important;\n    }\n    .edit-text-box .text-input{\n        width:100% !important;\n    }\n}\n::ng-deep .empty-head-icon{\n    padding-top:5px !important;\n    background-image: linear-gradient(to top, #accbee 0%, #e7f0fd 100%) !important;\n}\n\n\ninput[type=\"search\"]::-webkit-search-cancel-button {\n    -webkit-appearance: searchfield-cancel-button;\n    // cursor: pointer;\n    padding-bottom: 3px;\n    margin: 4px 0px 0px 0px; \n    position: relative;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
